const API_SERVER = "https://walking-pet-backend.onrender.com";
export default API_SERVER;
